import React from "react";
import { FormattedMessage } from "react-intl";
import Layout from "../../../components/Layout";
import messages from "../../../locale/messages";
import s from "./OurPartners.css";
import cx from "classnames";
import withStyles from "isomorphic-style-loader/lib/withStyles";

const WEBSITE_URL = process.env.WEBSITE_URL;

import g1 from "../../../../public/SiteImages/partner1.svg";
import g2 from "../../../../public/SiteImages/partner2.svg";
import g3 from "../../../../public/SiteImages/partner3.svg";
import g4 from "../../../../public/SiteImages/partner4.svg";
import g5 from "../../../../public/SiteImages/partner5.svg";
import g6 from "../../../../public/SiteImages/partner6.svg";
import rightImg from "../../../../public/SiteImages/rightImg.svg";
import leftImg from "../../../../public/SiteImages/leftImg.svg";

const OurPartnersContent = () => (
  <div className={cx(s.container)}>
    <h1 className={s.title}>
      <FormattedMessage {...messages.ourPartners} />
    </h1>

    <p className={s.description}>
      <FormattedMessage {...messages.ourPartnersDescription} />
    </p>

    <div className={s.partnerSection}>
      <div>
        <h2 className={s.partnerName}>
          <FormattedMessage {...messages.ourPartnersCharity} />
        </h2>
        <p className={s.partnerDescription}>
          <FormattedMessage {...messages.ourPartnersCharityDescription} />
        </p>
      </div>

      <div>
        <h2 className={s.partnerName}>
          <FormattedMessage {...messages.ourImpactTogether} />
        </h2>
        <p className={s.partnerDescription}>
          <FormattedMessage {...messages.ourImpactTogetherDesc} />
        </p>
      </div>

      <div>
        <h2 className={s.partnerName}>
          <FormattedMessage {...messages.partnersForCharity} />
        </h2>
        <div className={cx(s.paddingTop, "row")}>
          <div className="col-md-4 col-sm-4">
            <a
              href="https://www.petrescue.com.au/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <div className={s.charityBox}>
                <img className={s.imgResponsive} src={g1} />
                <img className={s.rightImg} src={rightImg} />
                <img className={s.leftImg} src={leftImg} />
                <h3>Animal Charity</h3>
                <hr></hr>
                <p>
                  {" "}
                  <FormattedMessage {...messages.charityImgContent} />{" "}
                </p>
              </div>
            </a>
          </div>
          <div className="col-md-4 col-sm-4">
            <a
              href="https://www.awlqld.com.au/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <div className={s.charityBox}>
                <img className={s.imgResponsive} src={g2} />
                <img className={s.rightImg} src={rightImg} />
                <img className={s.leftImg} src={leftImg} />
                <h3>Dog Charity</h3>
                <hr></hr>
                <p>
                  {" "}
                  <FormattedMessage {...messages.charityImgContent} />{" "}
                </p>
              </div>
            </a>
          </div>
          <div className="col-md-4 col-sm-4">
            <a
              href="https://www.petrescue.com.au/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <div className={s.charityBox}>
                <img className={s.imgResponsive} src={g3} />
                <img className={s.rightImg} src={rightImg} />
                <img className={s.leftImg} src={leftImg} />
                <h3>Save a Life</h3>
                <hr></hr>
                <p>
                  {" "}
                  <FormattedMessage {...messages.charityImgContent} />{" "}
                </p>
              </div>
            </a>
          </div>
        </div>

        <div className={cx(s.paddingTop, "row", s.mobileTop)}>
          <div className="col-md-4 col-sm-4">
            <a
              href="https://www.awlqld.com.au/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <div className={s.charityBox}>
                <img className={s.imgResponsive} src={g4} />
                <img className={s.rightImg} src={rightImg} />
                <img className={s.leftImg} src={leftImg} />
                <h3>Make a Difference</h3>
                <hr></hr>
                <p>
                  {" "}
                  <FormattedMessage {...messages.charityImgContent} />{" "}
                </p>
              </div>
            </a>
          </div>
          <div className="col-md-4 col-sm-4">
            <a
              href="https://www.petrescue.com.au/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <div className={s.charityBox}>
                <img className={s.imgResponsive} src={g5} />
                <img className={s.rightImg} src={rightImg} />
                <img className={s.leftImg} src={leftImg} />
                <h3>You Care</h3>
                <hr></hr>
                <p>
                  {" "}
                  <FormattedMessage {...messages.charityImgContent} />{" "}
                </p>
              </div>
            </a>
          </div>
          <div className="col-md-4 col-sm-4">
            <a
              href="https://www.awlqld.com.au/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <div className={s.charityBox}>
                <img className={s.imgResponsive} src={g6} />
                <img className={s.rightImg} src={rightImg} />
                <img className={s.leftImg} src={leftImg} />
                <h3>Pet Love</h3>
                <hr></hr>
                <p>
                  {" "}
                  <FormattedMessage {...messages.charityImgContent} />{" "}
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div className={s.contentColumn}>
        <h2 className={cx(s.sectionTitle, s.donateTxt)}>
          <FormattedMessage {...messages.howToDonate} />
        </h2>

        <ul className={s.donationList}>
          <li>
            <FormattedMessage {...messages.howToDonateOne} />
          </li>
          <li>
            <FormattedMessage {...messages.howToDonateTwo} />
          </li>
          <li>
            <FormattedMessage {...messages.howToDonateThree} />
          </li>
          <li>
            <FormattedMessage {...messages.howToDonateFour} />
          </li>
        </ul>
      </div>

      {/* <div className={s.partnerCard}>
        <h2 className={s.partnerName}>
          howToDonateOne, howToDonateTwo, howToDonateThree, howToDonateFour
          <FormattedMessage {...messages.howToDonate} />

        </h2>
      </div> */}
    </div>
  </div>
);

const StyledContent = withStyles(s)(OurPartnersContent);

export default function action({ intl }) {
  const pageTitle = intl.formatMessage(messages.ourPartners);

  return {
    title: pageTitle,
    component: (
      <Layout>
        <StyledContent />
      </Layout>
    ),
  };
}
